/* eslint-disable @typescript-eslint/no-explicit-any */
import { SystemConstants } from "@/common/system-constants";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import HttpClient from "./HttpClient";
import { APIHosts, ApiReduxHelpers } from "./reduxHelpers";


export interface ExtractFileRequest {
  guid_file: string;
  path_file: string;
}


export interface FileAnalytic {
  task: any;
  file_upload: any;
  _id: string;
  guid_file: string;
  name_file: string;
  path_file: string;
  file_id_project: string;
  irai_id: string;
  type_extract: string;
};

export interface FileAnalyticStatus {
  total_page: any;
  _id: string;
  irai_id: string;
  guid_file: string;
  type: string;
  sum_page: number;
  current_page: number;
  status: string;
  verify: boolean;
}

export interface ViewFileRequest {
  filename: string;
  baseFileId: string;
  baseMinorRev: string;
  baseMajorRev: string;
}



class DocAIController extends ApiReduxHelpers {

  ApiHost = APIHosts.DOCAI;

  public Post = {
    extractFileByPathFile: (data: ExtractFileRequest) => {
      const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_DOCAI.API.FILE.EXTRACT_FILE_BY_PATH}`;
      console.log("ExtractFileByPathFile URL:", url);
      return HttpClient.post(url, data).pipe(map((res) => res as FileAnalytic));
    },
  };

  public Get = {
    getTaskByGuidFile: (guid_file: string) => {
      const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_DOCAI.API.TASK.GET_BY_GUID(guid_file)}`;
      return HttpClient.get(url).pipe(map((res) => res as FileAnalyticStatus));
    },
    viewFileAnalytic: (data: ViewFileRequest) => {
      const url = `${this.getHost(this.ApiHost)}/${SystemConstants.SERVER_DOCAI.API.TASK.GET_BY_GUID(data.baseFileId)}`;
      return HttpClient.get(url).pipe(map((res) => res as FileAnalyticStatus));
    },
  };
}

export const DOCAIApi = new DocAIController();
